import MainError from './MainError';

export default MainError;
